export default __webpack_public_path__ + "iconeinformation.png";